// extracted by mini-css-extract-plugin
export default {"searchStateResults":"CustomStateResults-module--search-state-results--09c3a"};